<div class="d-inline-block" ngbDropdown >
    <a class="text fw-normal size15 txt-remove mr-2" id="dropdownManual" ngbDropdownToggle role="button">
        {{title}}
    </a>
    <ul  ngbDropdownMenu class="dropdown-menu multi-level" role="menu">

      <li *ngFor="let item of massModifyItems" class="{{item.styleClass}}">

        <a  *ngIf="item.title"
            (click)="clickChoiceButtonMassModify(item.value)"
            ngbDropdownItem tabindex="-1" 
            href="javascript:void(0);">
            {{item.title}}
        </a>

        <ul *ngIf="item.choice" class="dropdown-menu">
          <li *ngFor="let subitem of item.choice" class="{{subitem.styleClass}}">
            <a  *ngIf="subitem.title"
                ngbDropdownItem tabindex="-1" 
                (click)="clickChoiceButtonMassModify(subitem.value)"
                href="javascript:void(0);">
                {{subitem.title}}   
            </a>
            </li>
        </ul>
      </li>
    </ul>   
  </div>